import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, of, Subject } from 'rxjs';
import { ErrorMessageService } from './error-message.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiCallService {
  
  private SaveSiteId = new Subject<any>();
  private SaveSites = new Subject<any>();
  private POInvoice = new Subject<any>();
  private WOJobSheet = new Subject<any>();
  
  constructor(private errorMessageService: ErrorMessageService) { }

  apiCall<T>(
    request: Observable<HttpResponse<T>>,
    progressAction: (isInProgress: boolean, isError: boolean, errorMessage: string) => void,
    doneAction: (response: T) => void
  ): Subscription {
    progressAction(true, false, '');
    return request
      .subscribe((response) => {
        progressAction(false, false, '');
        doneAction(response.body as T);
      }, (error: any) => {
        const errorMessage = this.errorMessageService.getMessage(error);
        progressAction(false, true, errorMessage);
      });
  };

  defaultIfError<T>(
    request: Observable<HttpResponse<T>>,
    defaultValue: T
  ): Observable<T | null> {
    return request.pipe(map(x => x.body))
      .pipe(catchError(error => of(defaultValue)));
  }

  sendSaveSiteId(): void {
    this.SaveSiteId.next();
  }

  getSaveSiteId(): Observable<any> {
    return this.SaveSiteId.asObservable();
  }

  SaveSite(): void {
    this.SaveSites.next();
  }

  getSite(): Observable<any> {
    return this.SaveSites.asObservable();
  }

  sendSavePOInvoice(): void {
    this.POInvoice.next();
  }
  
  getSavePOInvoice(): Observable<any> {
    return this.POInvoice.asObservable();
  }

  sendSaveWOJobSheet(): void {
    this.WOJobSheet.next();
  }
  
  getSaveWOJobSheet(): Observable<any> {
    return this.WOJobSheet.asObservable();
  }
}
